import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

export const campP7PoorRoasReorder: FaireAdCampaignEntity = {
  token: "camp_p7_poor_roas_reorder",
  type: "adCampaign",
  advertiserProfileToken: "adv_p7_poor_roas",
  segment: "REORDER_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 200,
  startedRunningAt: "2025-02-20",
  segmentMetrics: {
    numReorderConversions: 0,
    salesDollars: 0,
    totalAdsSpendDollars: 0,
    returnOnAdSpend: 0,
  },
  performancePeriodTokens: [
    "perf_p7_poor_roas_reorder_202602",
    "perf_p7_poor_roas_reorder_202603",
    "perf_p7_poor_roas_reorder_202604",
    "perf_p7_poor_roas_reorder_202605",
    "perf_p7_poor_roas_reorder_202606",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
